import { httpRequest } from "../../../utils/HttpRequest";
import { ITeamDetail } from "./TeamTypes";
import { IPage } from "@/types/AppTypes";

class TeamService {
    async page(searchVo: ITeamDetail) {
        const apiUrl = "/web/teamstyle/search_page";
        return await httpRequest.post<IPage<ITeamDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/web/teamstyle/search_one/${id}`;
        return await httpRequest.get<ITeamDetail>(apiUrl);
    }
    async insert(insertVo: ITeamDetail) {
        const apiUrl = `/web/teamstyle/insert`;
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: ITeamDetail) {
        const apiUrl = `/web/teamstyle/update`;
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async delete(id: string) {
        const apiUrl = `/web/teamstyle/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
}
export const teamService = new TeamService();
